import { useQuery } from "@tanstack/react-query";
import i18n from "i18n";
import { AIModelProvider } from "@graylog/enterprise-api";
import { defaultOnError } from "util/conditional/onError";
import { toProviderAuth } from "ai-management/providerAuth";
export const MODEL_PROVIDER_CONFIG_QUERY_KEY = ["ai-model-provider-config"];
const EMPTY_CONFIG = { providers: [], default_provider: null, default_model_id: null };
const toCredentialsJson = (credentials) => ({
  provider: credentials.provider,
  auth: toProviderAuth(credentials.auth)
});
const toConfigJson = (config) => ({
  providers: config.providers.map(toCredentialsJson),
  default_provider: config.default_provider,
  default_model_id: config.default_model_id
});
const useModelProviderConfig = () => {
  const { data, isLoading, refetch } = useQuery({
    queryKey: MODEL_PROVIDER_CONFIG_QUERY_KEY,
    queryFn: () => defaultOnError(
      AIModelProvider.getConfig().then(toConfigJson),
      i18n.t("notifications.model_provider_config_load_message", { ns: "enterprise_ai" }),
      i18n.t("notifications.model_provider_config_load_title", { ns: "enterprise_ai" })
    )
  });
  return { data: data != null ? data : EMPTY_CONFIG, isLoading, refetch };
};
export default useModelProviderConfig;
